/* eslint-disable */
// Define assets path "On The Fly"
import util from "src/js/utils";

__webpack_public_path__ = window.inx.params.project.path.assets;
/* eslint-enable */
import showWeather from "src/js/modules/weather";
import showInboxNews from './widget/news-client';
import initializeTopNews from './news/initialize_top_news';
import fallbackBannerCheck from './modules/fallback-banner';
import syncSystemThemeLogos from './modules/system-theme-logos';
import { initCategorySlider } from './news/category_slider';
import csrf_protection from "./csrf_protection";

const fireUpPortal = () => {
    const { inx: { weather, news_conf } } = window;

    // This function is called from ADS system when a side banner is loaded
    window.updateSideBannerDesign = function () {
        // console.log('updateSideBannerDesign');
        // //load sbv2.css if not already loaded. we load custom css grid on-demand for performance (page size) reasons
        const sbv2Css = document.querySelector('#sbv2-css');
        if (!sbv2Css) {
            const link = document.createElement('link');
            link.setAttribute('id', 'sbv2-css');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', window.inx.params.project.path.assets + 'css/sbv2.css');
            document.head.appendChild(link);
        }
    };

    //set up CSRF protection on page load for legacy hidden form
    csrf_protection();

    util.reloadIfHttpsAvailable();

    if (news_conf) {
        initializeTopNews(news_conf);
    }

    // Weather in the header
    if (weather && weather.enabled) {
        setTimeout(() => {
            showWeather(weather);
        }, 0);
    }

    fallbackBannerCheck();
    syncSystemThemeLogos();
    initCategorySlider(); //horizontal scroll. added here as when added inside news code it does not work somehow

    // Show inbox news when enabled
    // alternative to DOMContentLoaded
    document.onreadystatechange = function () {
        if (document.readyState === "interactive") {
            window.inx.newsClient && showInboxNews();
        }
    }
};

fireUpPortal();
